const oidcUserStorageKey = () =>
    `oidc.user:${process.env.REACT_APP_AUTHORITY}:${process.env.REACT_APP_CLIENT_ID}`;

export const getStoredAccessToken = (): string | undefined => {
    const authData = window.sessionStorage.getItem(oidcUserStorageKey());
    if (!authData) return undefined;

    try {
        return JSON.parse(authData).access_token;
    } catch {
        return undefined;
    }
};

export const ensureOfflineAccessScope = (scope?: string): string => {
    const scopes = new Set((scope ?? '').split(' ').filter(Boolean));
    scopes.add('offline_access');
    return Array.from(scopes).join(' ');
};
